<template lang="pug">
#password-reset.section
  .columns
    .column.is-one-third.is-offset-one-third
      .login-form.box
        spinner(v-if="settings.loading")
        div(v-else)
          .has-text-centered
            h4.is-size-4 Password Reset
          b-notification(v-if="message.success" type="is-success") {{ message.success }}
          b-notification(v-else-if="message.error" type="is-danger") {{ message.error }}
          b-notification(v-else-if="!ses") Enter your email address and we will send you a link to reset your password
          form(v-if="!message.error" @submit.prevent="submit" novalidate)
            div(v-if="ses")
              b-field(
                label="Password"
                :type="errors.has('password') ? 'is-danger' : ''"
                :message="errors.first('password')"
              )
                b-input(
                  type="password"
                  name="password"
                  ref="password"
                  v-validate="'required|password'"
                  data-vv-delay="1000"
                  v-model="credentials.password"
                  password-reveal
                )
              b-field(
                label="Confirm Password"
                :type="errors.has('password_confirm') ? 'is-danger' : ''"
                :message="errors.first('password_confirm')"
              )
                b-input(
                  type="password"
                  name="password_confirm"
                  v-validate="'required|confirmed:password|password'"
                  data-vv-as="password"
                  data-vv-delay="1000"
                  v-model="credentials.password_confirm"
                  password-reveal
                )
              .buttons
                button.button.is-primary(
                  type="submit"
                  :class="{ 'is-loading': settings.submitting }"
                ) Update Password
                router-link.button.is-text.has-text-primary(v-if="message.success" :to="{ name: 'login' }") Login
            div(v-else)
              b-field(
                label="Email"
                :type="errors.has('email') ? 'is-danger' : ''"
                :message="errors.has('email') ? errors.first('email') : ''"
              )
                b-input(v-model="credentials.email" name="email" v-validate="'required'")
              .buttons
                button.button.is-primary(
                  type="submit"
                  :class="{ 'is-loading': settings.submitting }"
                ) Request Reset
                router-link.button.is-text.has-text-primary(:to="{ name: 'login' }") Login
</template>

<script>
import { mapGetters } from 'vuex';
import { HTTP } from '@/utils/http';
import moment from 'moment';
import Spinner from '@/components/Spinner';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';

export default {
  name: 'password-reset',
  components: {
    Spinner,
  },
  computed: {
    ...mapGetters({
      user: getters.GET_USER,
    }),
  },
  async created() {
    if (this.ses) {
      this.settings.loading = true;
      try {
        await this.$store.dispatch(actions.DO_GET_USER, {
          id: this.ses,
        });
        const now = moment();
        if (now.isAfter(this.user.reset_expires)) { this.message.error = 'This link has expired'; }
      } catch (e) {
        this.message.error = 'Invalid link';
      } finally {
        this.settings.loading = false;
      }
    }
  },
  data() {
    return {
      credentials: {},
      message: {
        error: null,
        success: null,
      },
      settings: {
        loading: false,
        submitting: false,
      },
    };
  },
  methods: {
    async resetPassword() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.settings.submitting = true;
        const response = await this.$store.dispatch(actions.DO_UPDATE_USER, {
          id: this.user.id,
          password: this.credentials.password,
          password_reset_key: this.ses,
        });
        this.message.success = response.message;
        this.settings.submitting = false;
        this.credentials = {};
      }
    },
    async requestPasswordReset() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.settings.submitting = true;
        const { data } = await HTTP.post('/users/_password_reset', {
          email: this.credentials.email,
        });
        this.message.success = data.message;
        this.settings.submitting = false;
        this.credentials = {};
      }
    },
    async submit() {
      if (this.ses) {
        await this.resetPassword();
      } else {
        await this.requestPasswordReset();
      }
    },
  },
  props: ['ses'],
};
</script>

<style lang="scss">
#password-reset {
  height: 100vh;
  background-image: url('/static/bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  .notification {
    margin: 0.75rem 0;
  }
  .login-form {
    margin-top: 80px;
  }
  .buttons {
    margin-top: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PasswordReset.vue